import { useState } from "react";
import { useRouter } from "next/router";
import AlertModal from "../Modal/AlertModal/AlertModal";
import exit from "../../utils/common/exit";
import styles from "./Exit.module.scss";
import { useRecord } from "../../utils/customHook/useRecord";
import { useSelector } from "react-redux";
import { useRoomConnection } from "../../utils/customHook/useRoomConnection";
import { FiX } from "react-icons/fi";

const Exit = ({ fixed, top, left, right, bottom, black }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const router = useRouter();
  const { stopRecordHandler } = useRecord();
  const userInfo = useSelector((state) => state.userInfo);
  const { sendToExamTopic } = useRoomConnection();
  const socketData = useSelector((state) => state.socket);

  const onClick = () => {
    if (!userInfo.isPreCheck) {
      sendToExamTopic(socketData?.viewerSocket?.viewerSocketId, "EXIT");
      stopRecordHandler();
    }
    exit(router);
    setModalOpen(false);
  };

  return (
    <div
      className={styles.wrap}
      style={{ position: fixed ? "fixed" : "", top, left, right, bottom }}
    >
      <FiX
        onClick={() => setModalOpen(true)}
        style={{ color: black ? "#222" : "" }}
      />
      {isModalOpen && (
        <AlertModal
          setModalOpen={setModalOpen}
          blur
          buttonText="종료"
          buttonColor="gold"
          onClick={onClick}
          darkBg
        >
          <div className={styles.modalText}>프로그램을 종료하시겠습니까?</div>
        </AlertModal>
      )}
    </div>
  );
};

export default Exit;
